import { 
	ApolloClient, 
	InMemoryCache, 
	// HttpLink, 
	ApolloLink,
	// concat
} from '@apollo/client';
// import { onError } from '@apollo/client/link/error';
import { onError } from 'apollo-link-error';
import { recoverSession, deleteSession } from '../utils/session';

import { WebSocketLink } from 'apollo-link-ws';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { createUploadLink } from 'apollo-upload-client';
import { split } from 'apollo-link';
import { getMainDefinition } from 'apollo-utilities';

/* Configuration imported from '.env' file */
// const backendWSProtocol = process.env.REACT_APP_WS_PROTOCOL;
// const backendProtocol 	= process.env.REACT_APP_PROTOCOL;
// const backendHost 		= process.env.REACT_APP_HOST;
// const backendPort 		= process.env.REACT_APP_PORT;
// const backendGraphql 	= process.env.REACT_APP_GRAPHQL;

// const backendAddress = `${backendProtocol}://${backendHost}:${backendPort}${backendGraphql}`;

const BackendUrl = process.env.REACT_APP_BACKEND;
const WebsocketUrl = process.env.REACT_APP_WS;

// const httpLink = new HttpLink({
// 	uri: backendAddress
// });
const httpLink = new createUploadLink({
	uri: `${BackendUrl}/graphql`
});

const authMiddleware = new ApolloLink((operation, forward) => {
	const token = recoverSession('token');
	const authorization = token ? `Bearer ${token}` : '';
	operation.setContext(({ headers = {} }) => ({
		headers: {
			...headers,
			authorization,
		},
	}));
	// console.log('operation', operation);
	return forward(operation);
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
	if (graphQLErrors) {
		graphQLErrors.forEach(err => {
			// err.message, err.locations, err.path, err.extensions
			if (err.extensions && (err.extensions.code === 'UNAUTHENTICATED' || err.extensions.code === 'FORBIDDEN')) {
				deleteSession();
				window.location.href = '/';
			}
		});
	}

	// console.log('networkError', networkError);
	if (networkError && networkError.response === 'invalid_token') {
		deleteSession();
		window.location.href = '/';
	}
});

// web socket link config
const wsClient = new SubscriptionClient(`${WebsocketUrl}/subscriptions`, {
	reconnect: true,
	lazy: true,
	connectionParams: {
		authToken: recoverSession('token') ? `Bearer ${recoverSession('token')}` : ''
	}
});
const wsLink = new WebSocketLink(wsClient);

// const link_merge = ApolloLink.from([authMiddleware, wsLink, httpLink, errorLink]);
// const link_merge = concat(authMiddleware, httpLink, wsLink, errorLink);
const requestLink = split(
	// split based on operation type
	({ query }) => {
	  const definition = getMainDefinition(query);
	  return (
		definition.kind === 'OperationDefinition' &&
		definition.operation === 'subscription'
	  );
	},
	wsLink,
	authMiddleware.concat(httpLink)
);

const link_merge = ApolloLink.from([errorLink, requestLink]);

export const cache = new InMemoryCache({
	dataIdFromObject: object => object.key || null, // avoiding merging of of two seperate data with the same id
	// improving speed performance
	cacheRedirects: {
		// avoid requesting the same data that already in the client that has different key
		Query: {
			// users: (_, args) => toIdValue(cache.config.dataIdFromObject({ __typename: 'Users', uid: args.uid })),
		},
	},
});

const apolloClient = new ApolloClient({
	// link,
	// cache: new InMemoryCache()
	link: link_merge,
	cache
});

export default apolloClient;
